import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  createGranularRequestConfig,
  GranularCatalogConfig,
} from "@granular/fabric-catalog-helpers";
import {
  FieldEnrollmentListResponse,
  CreateFieldEnrollmentRequest,
  FieldEnrollmentResponse,
} from "../../schemas";

const GET = async (
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<FieldEnrollmentListResponse>> => {
  const response = await axios.get(
    "/api/enrollments-svc-lambda/enrollment/field",
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

const POST = async (
  enrollment: CreateFieldEnrollmentRequest,
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<FieldEnrollmentResponse[]>> => {
  const response = await axios.post(
    "/api/enrollments-svc-lambda/enrollment/field",
    enrollment,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

export default {
  GET,
  POST,
};
